import { YodaColors, YodaSpacing } from 'yoda-ui/yodaTheme';

export const tooltipStyle = {
  paddingLeft: YodaSpacing.small,
  paddingRight: YodaSpacing.small,
  backgroundColor: YodaColors.primaryBlue,
};

export const arrowStyle = {
  color: YodaColors.primaryBlue,
};
